import React from 'react'
import { tv } from 'tailwind-variants'

// The shimmer is a white sweep; on the dark theme's skeleton colour the light
// theme's strength glares, so it's fainter there.
const skeleton = tv({
  base: 'rounded-lg inline-block h-4 relative overflow-hidden bg-skeleton after:absolute after:top-0 after:right-0 after:bottom-0 after:left-0 after:bg-[linear-gradient(90deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.2)_20%,rgba(255,255,255,0.5)_60%,rgba(255,255,255,0)_100%)] dark:after:bg-[linear-gradient(90deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.03)_20%,rgba(255,255,255,0.08)_60%,rgba(255,255,255,0)_100%)] after:animate-shimmer after:content-[""]'
})

const Skeleton = ({ className = '', style }: { className?: string; style?: React.CSSProperties }) => {
  return <div className={skeleton({ class: className })} style={style} />
}

export default Skeleton
